var render, staticRenderFns
import script from "./AssemblyLayout.vue?vue&type=script&lang=js"
export * from "./AssemblyLayout.vue?vue&type=script&lang=js"
import style0 from "./AssemblyLayout.vue?vue&type=style&index=0&id=262d745c&prod&scoped=true&lang=scss"
import style1 from "./AssemblyLayout.vue?vue&type=style&index=1&id=262d745c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262d745c",
  null
  
)

export default component.exports